var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinitruckBlueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 114,
    viewBox: "0 0 165 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minitruck-blue-bg",
    transform: "translate(-219 -1068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 165,
    height: 114,
    rx: 20,
    transform: "translate(219 1068)",
    fill: "#04a8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Mini_Truck",
    "data-name": "Mini Truck",
    transform: "translate(259 1159)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MINI TRUCK")), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(-1478.898 -1509.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M1764.914,2630.181c1.8-1.552.157-3.714,1.493-5.471.744-.651,1.928-.314,3.031-.317,21.157-.045,42.313,0,63.468-.182,3.55-.031,4.672,1.123,4.328,4.529-.262,2.571-.052,5.189-.052,7.941-1.526.071-2.546.211-3.554.147-1.788-.113-2.515.647-2.374,2.417s-.139,3.375-2.43,3.211c-2.045-.148-4.556,1.284-5.659-2.125-1.528-4.724-5.052-7.219-10.05-7.391-4.568-.158-8.433,2.379-10.263,7.109-.817,2.111-1.906,2.641-4.024,2.627q-21.1-.13-42.2.01c-2.032.014-2.963-.476-3.673-2.508a10.049,10.049,0,0,0-9.475-7.216c-4.835-.252-8.312,1.984-10.472,6.306-1,2.009-5.812,3.055-7.977,1.755-1.276-.766-2.18-5.247-.925-6.62a4.732,4.732,0,0,0,1.156-3.678c-.021-10.574,4.115-19.775,9.478-28.562a7.183,7.183,0,0,1,6.621-3.528c6.179.021,12.36.1,18.536-.055,2.771-.068,3.609,1.141,3.59,3.682-.059,8.233-.038,16.469,0,24.7C1763.493,2628.1,1762.907,2629.573,1764.914,2630.181Zm-28.412-13.64c5.814,0,11.067-.033,16.32.019,1.793.018,2.806-.5,2.765-2.509q-.111-5.311,0-10.624c.041-1.809-.789-2.438-2.47-2.421-3.768.037-7.538,0-11.307.036a4.684,4.684,0,0,0-4.118,2.048,36.075,36.075,0,0,0-4.7,9.542C1735.308,2613.02,1737.115,2613.683,1736.5,2616.542Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M1828.762,2647.214a8.306,8.306,0,1,1-16.608-.262,8.3,8.3,0,0,1,8.412-8.161A8.4,8.4,0,0,1,1828.762,2647.214Z",
    transform: "translate(-7.464 -3.386)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M1743.655,2655.594c-4.289-.028-8.073-4.028-8.082-8.542a8.342,8.342,0,0,1,8.282-8.3,8.513,8.513,0,0,1,8.3,8.339A8.842,8.842,0,0,1,1743.655,2655.594Z",
    transform: "translate(-1.016 -3.383)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinitruckBlueBg);
export default __webpack_public_path__ + "static/media/minitruck-blue-bg.cee7a747cc55ae229436eeadeecf9445.svg";
export { ForwardRef as ReactComponent };